import {createSlice} from "@reduxjs/toolkit";

const initialFacultyMembersState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  facultyMemberForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const facultyMembersSlice = createSlice({
  name: "facultyMembers",
  initialState: initialFacultyMembersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getFacultyMemberById
    facultyMemberFetched: (state, action) => {
      state.actionsLoading = false;
      state.facultyMemberForEdit = action.payload.facultyMemberForEdit;
      state.error = null;
    },
    // findFacultyMembers
    facultyMembersFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createFacultyMember
    facultyMemberCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.facultyMember);
    },
    // updateFacultyMember
    facultyMemberUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.facultyMemberId === action.payload.facultyMember.facultyMemberId) {
          return action.payload.facultyMember;
        }
        return entity;
      });
    },
    // deleteFacultyMember
    facultyMemberDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.facultyMemberId !== action.payload.facultyMemberId);
    },
    // deleteFacultyMembers
    facultyMembersDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.facultyMemberId)
      );
    },
  }
});
